module.exports = __webpack_public_path__ + "img/F.5fd6ce8b.png";